export default "__VITE_ASSET__BLVklZgh__"